import { IconRibbon } from '@/icons/IconRibbon';

const BundleOfferBadge = ({ className = '' }: { className?: string }) => {
  return (
    <div
      data-testid="bundle-offer-badge"
      className={`relative flex items-center gap-4 overflow-hidden rounded-lg border border-purple-200 bg-gradient-to-r from-purple-50 to-white px-5 py-4 ${className}`}
    >
      {/* Stripe is anchored to the card (not the icon wrapper) so it always spans top to bottom.
          left = card padding (1.25rem) + half the icon column (1.375rem) - half the stripe (0.25rem). */}
      <div className="absolute inset-y-0 left-[2.375rem] w-2 bg-purple-500/20" aria-hidden="true" />
      <div className="relative flex w-11 shrink-0 items-center justify-center" aria-hidden="true">
        <IconRibbon className="h-11 w-11" />
      </div>
      <div>
        <div className="text-lg font-semibold text-purple-700">Bundle Offer Available</div>
        <div className="text-sm text-gray-600">Save more when you buy together</div>
      </div>
    </div>
  );
};

export default BundleOfferBadge;
